import { SDKComponentsTypes } from 'src/service/scene/enums';

export const isMediaType = (node) => {
  return (
    node.componentType === SDKComponentsTypes.Image ||
    node.componentType === SDKComponentsTypes.GIFLoader ||
    node.componentType === SDKComponentsTypes.VideoRenderer
  );
};
